// History of changes (docs/mastermind-admin-plan.md 3.3), folded, for Adam only: every change to the
// member's goal and actions (hub.accountability_events, written by triggers whoever made it) and the
// audit lines beside them (register marks, catch-ups, months closed, the log sent or saved), the 20 newest
// first with Show more. It's read when it's opened (hub.mastermind_history). The old site's copied lines (made outside
// anyone's login, up to the day the hub started keeping the record) are 1 fold of their own, "From the old site's copy
// (12 changes)", and any such line after it is "A fix to the record" (the critique's admin 13).
import { useState } from 'react'
import { Button, Card, Loading, Problem, useAdmin, useLoad } from '../ui/index.js'
import { MM } from './words.js'
import { loadHistory } from './data.js'
import { fromCopy, historyLine } from './section.js'

function History({ log, first }) {
  const { api } = useAdmin()
  const [count, setCount] = useState(20)
  const rows = useLoad(() => loadHistory(api, log.person.person_id, log.product.product_id), [api, log.person.person_id, log.product.product_id, log.as_at])
  if (rows.status === 'loading' && !rows.data) return <Loading />
  if (!rows.data) return <Problem error={rows.error} onRetry={rows.reload} />
  const since = log.copied?.since || null
  const lines = rows.data.map(h => ({
    key: `${h.source}-${h.kind}-${h.at}-${h.action_id || h.goal_id || h.session_id || ''}`,
    text: historyLine(h, { first, sessions: log.sessions, since }), copy: fromCopy(h, since),
  })).filter(l => l.text)
  if (!lines.length) return <p className="amx-muted">{MM.historyNone}</p>
  const own = lines.filter(l => !l.copy)
  const copied = lines.filter(l => l.copy)
  return (
    <>
      {own.length > 0 && <ul className="amx-history">{own.slice(0, count).map((l, i) => <li key={`${l.key}-${i}`}>{l.text}</li>)}</ul>}
      {own.length > count && <span><Button size="sm" kind="quiet" onClick={() => setCount(c => c + 20)}>{MM.showMore}</Button></span>}
      {copied.length > 0 && (
        <details className="amx-copied">
          <summary className="amx-copied-head">{MM.copiedFold(copied.length)}</summary>
          <ul className="amx-history">{copied.map((l, i) => <li key={`${l.key}-${i}`}>{l.text}</li>)}</ul>
        </details>
      )}
    </>
  )
}

export function ChangesCard({ log, first }) {
  const [open, setOpen] = useState(false)
  return (
    <Card className="amx-changes" body={false} labelledBy="mm-changes-h">
      <details className="amx-fold" onToggle={e => setOpen(e.currentTarget.open)}>
        <summary className="amx-fold-head"><h2 className="ad-card-title" id="mm-changes-h">{MM.historyH}</h2></summary>
        <div className="amx-fold-body">{open && <History log={log} first={first} />}</div>
      </details>
    </Card>
  )
}
